import React from "react";
import FeedbackButtons from "./FeedbackButtons";

/**
 * Unified site footer used across all pages.
 * Render this OUTSIDE any constrained container (e.g. .gallery-container) — it
 * is meant to span the full viewport width naturally without breakout hacks.
 */
export default function SiteFooter() {
  return (
    <footer
      className="footer"
      data-testid="site-footer"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "2rem",
        flexWrap: "wrap",
        padding: "4rem 1.5rem",
        background: "linear-gradient(135deg, #1f2937 0%, #111827 100%)",
        color: "white",
        textAlign: "center",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <a href="https://countryscanner.ru/">
        <img
          src="/game/cs_logo.png"
          alt="Country Scanner"
          style={{
            height: "30px",
            width: "auto",
            filter: "brightness(0) invert(1)",
            opacity: 0.9,
          }}
        />
      </a>
      <span>© 2015 - {new Date().getFullYear()}</span>
      <a
        href="mailto:info@countryscanner.ru"
        style={{ color: "rgba(255,255,255,0.8)", textDecoration: "none" }}
      >
        info@countryscanner.ru
      </a>
      <FeedbackButtons />
    </footer>
  );
}
